import { jsx } from "panel";
import { AsyncButtonEl } from "common/components/async-button";
import { BannerEl } from "common/components/banner";
import { ButtonEl } from "common/components/button";
import { InputEl } from "common/components/input";
import { ModalEl } from "common/components/modal";
import { SelectEl } from "common/components/select";
import { BannerAction, BannerType } from "common/components/banner/types";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { getEntityTypeName } from "common/report/util/saved-entities";
import { SharingBannerEl } from "../sharing/banner";
export function template() {
  const { description, globalAccessType, name, saving } = this.state;
  const entityTypeNamePlural = this.getContext(`i18n`).print(
    getEntityTypeName(this.attr(`entity-type`), {
      plural: true
    })
  );
  const NameInput = (props = {}) => {
    var _a, _b;
    return /* @__PURE__ */ jsx(
      InputEl,
      {
        attrs: {
          placeholder: (_a = props == null ? void 0 : props.placeHolderValue) != null ? _a : this.t(`components.create-entity.untitled`, { context: this.attr(`entity-type`) }),
          label: (_b = props == null ? void 0 : props.label) != null ? _b : this.t(`components.create-entity.name`),
          "validation-status": this.getNameError() ? `invalid` : ``,
          "error-message": this.getNameError() || ``,
          elref: `entityNameInput`,
          disabled: this.helpers.isSavingRestricted()
        },
        props: {
          value: name
        },
        on: {
          input: this.helpers.handleNameInput,
          keydown: this.helpers.handleKeydown
        },
        hook: {
          insert: ({ elm }) => this.setElRef(`nameInput`, elm),
          destroy: () => this.setElRef(`nameInput`, null)
        }
      }
    );
  };
  const InputDescription = ({ text, learnMoreLink }) => /* @__PURE__ */ jsx("div", { sel: ".input-description" }, /* @__PURE__ */ jsx("div", { sel: ".input-description-text" }, text ? text : ``), learnMoreLink ? /* @__PURE__ */ jsx(
    "a",
    {
      sel: ".input-description-learn-more",
      attrs: {
        href: learnMoreLink,
        target: `_blank`
      }
    },
    this.t(`common.learn-more`)
  ) : null);
  return /* @__PURE__ */ jsx(
    ModalEl,
    {
      sel: ".modal.create-entity-modal",
      attrs: {
        open: this.attr(`open`),
        closeable: this.attr(`closeable`),
        "modal-title": this.attr(`modal-title`),
        "modal-description": `Modal for managing ${entityTypeNamePlural}`
      },
      on: { change: this.helpers.handleModalChange }
    },
    /* @__PURE__ */ jsx("div", { sel: ".mp-card-header" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-title" }, this.attr(`modal-title`))),
    /* @__PURE__ */ jsx("div", { sel: ".mp-modal-content" }, this.helpers.limitBannerRenderer(), this.helpers.isSavingRestricted() ? /* @__PURE__ */ jsx(
      BannerEl,
      {
        sel: ".banner",
        attrs: {
          theme: `info`,
          type: BannerType.Embedded,
          "header-text": this.t(`components.create-entity.cohort-save-upgrade`),
          "body-text": this.t(`components.create-entity.cohort-save-upgrade-description`),
          ctas: [{ text: this.t(`common.upgrade`), icon: `share`, actionName: BannerAction.Upgrade }],
          "style-override": `.banner-wrapper .banner-panel .banner-copy {width: calc(100% - 130px)}`
        },
        on: {
          action: this.helpers.openPricingUpsell
        }
      }
    ) : /* @__PURE__ */ jsx(null, null, !this.attr(`show-global-access-menu`) || this.helpers.userLacksSharePermission() ? /* @__PURE__ */ jsx(
      SharingBannerEl,
      {
        sel: ".banner",
        attrs: {
          "project-id": this.attr(`project-id`),
          "entity-type": this.attr(`entity-type`),
          "sub-entity-type": this.attr(`sub-entity-type`)
        }
      }
    ) : null, this.attr(`warning`) ? /* @__PURE__ */ jsx(
      BannerEl,
      {
        sel: ".banner",
        attrs: {
          theme: `warn`,
          type: BannerType.Embedded,
          "body-text": this.attr(`warning`)
        }
      }
    ) : null), this.attr(`entity-type`) === `data group` ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(
      NameInput,
      {
        label: this.t(`components.create-entity.group-property`),
        placeHolderValue: this.t(`components.create-entity.group-property-placeholder`)
      }
    ), /* @__PURE__ */ jsx(
      InputDescription,
      {
        text: this.t(`components.create-entity.group-property-description`),
        learnMoreLink: "https://help.mixpanel.com/hc/en-us/articles/360025333632#implementation"
      }
    ), /* @__PURE__ */ jsx(
      InputEl,
      {
        attrs: this.helpers.getDataGroupDescriptionInputAttrs(),
        props: { value: description },
        on: {
          input: this.helpers.handleDescriptionInput,
          keydown: this.helpers.handleKeydown
        },
        hook: {
          insert: ({ elm }) => this.setElRef(`descriptionTextarea`, elm),
          destroy: () => this.setElRef(`descriptionTextarea`, null)
        }
      }
    ), /* @__PURE__ */ jsx(InputDescription, { text: this.t(`components.create-entity.group-description`) })) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(NameInput, null), /* @__PURE__ */ jsx(
      InputEl,
      {
        attrs: this.helpers.getDescriptionInputAttrs(),
        props: { value: description },
        on: {
          input: this.helpers.handleDescriptionInput,
          keydown: this.helpers.handleKeydown
        },
        hook: {
          insert: ({ elm }) => this.setElRef(`descriptionTextarea`, elm),
          destroy: () => this.setElRef(`descriptionTextarea`, null)
        }
      }
    )), this.helpers.showGlobalAccessMenu() ? /* @__PURE__ */ jsx("div", { sel: ".global-access-container" }, /* @__PURE__ */ jsx("div", { sel: ".label" }, this.t(`components.create-entity.who-can-see`)), /* @__PURE__ */ jsx(
      SelectEl,
      {
        sel: ".global-access-select",
        attrs: {
          sections: this.helpers.getGlobalAccessTypeSections(),
          "selected-option": globalAccessType,
          "label-transform": `uppercase`,
          size: ButtonSize.Large,
          elref: `globalAccessMenu`
        },
        on: {
          change: this.helpers.handleGlobalAccessTypeChange
        }
      }
    )) : null, /* @__PURE__ */ jsx("div", { sel: ".modal-footer" }, /* @__PURE__ */ jsx("div", { sel: ".modal-actions" }, this.attr(`show-share-management`) && !this.attr(`show-copy-link-button`) ? /* @__PURE__ */ jsx("div", { sel: ".modal-actions-confrim-share-container" }, /* @__PURE__ */ jsx(
      ButtonEl,
      {
        attrs: {
          theme: ButtonTheme.Secondary,
          disabled: !this.helpers.formIsValid() || Boolean(saving),
          elref: `saveAndShareButton`
        },
        on: {
          click: () => this.helpers.saveChanges(true)
        }
      },
      this.helpers.showGlobalAccessMenu() ? this.t(`components.create-entity.customize-access`) : this.t(`components.create-entity.save-and-share`)
    )) : null, this.attr(`show-copy-link-button`) && !this.attr(`show-share-management`) ? /* @__PURE__ */ jsx("div", { sel: ".modal-actions-confrim-share-container" }, /* @__PURE__ */ jsx(
      AsyncButtonEl,
      {
        params: {
          asyncAction: this.helpers.copyLink,
          theme: ButtonTheme.Secondary,
          elref: `copyLinkButton`,
          icon: `link`
        }
      },
      this.t(`common.copy-url`)
    )) : null, /* @__PURE__ */ jsx("div", { sel: ".modal-actions-cancel-container" }, /* @__PURE__ */ jsx(
      ButtonEl,
      {
        sel: ".modal-actions-cancel",
        attrs: {
          theme: ButtonTheme.Tertiary,
          elref: `cancelButton`
        },
        on: {
          click: this.helpers.handleSaveModalCancel
        }
      },
      this.t(`common.cancel`)
    )), /* @__PURE__ */ jsx("div", { sel: ".modal-actions-confirm-container", on: { click: this.helpers.setSubmitAttempted } }, /* @__PURE__ */ jsx(
      ButtonEl,
      {
        sel: ".modal-actions-confirm",
        attrs: {
          theme: ButtonTheme.Primary,
          disabled: !this.helpers.formIsValid() || Boolean(saving),
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          icon: saving ? `spinner` : ``,
          elref: `saveEntityButton`
        },
        on: {
          click: () => this.helpers.saveChanges(false)
        }
      },
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      saving ? this.t(`common.saving`) : this.t(`common.save`)
    )))))
  );
}
